import React from 'react';
import Lookup from '../componentes/select-async';
import ChaveResultadoList from 'src/paginas/okr/Objetivo/ObjetivoCardView/Details/ObjetivoEditView/KR/KRListView/list';

const ChaveResultadoLookup = ({ ...rest }) => (
  <Lookup labelKey="descricao" valueKey="id" url="/ChaveResultadoLookup" searchComponent={ChaveResultadoList} showSearch {...rest} />
);

export default ChaveResultadoLookup;
